<template>
  <div class="l-learn-abc-explain-test">
    <!-- 视频讲解|答案视频 -->
    <div class="l-learn-abc-explain-test-video" v-if="stage === STAGE_TYPES.isVideoExplain ||
      stage === STAGE_TYPES.isPlayAnswerVideo
      ">
      <LLearnVideo ref="player" :options="{
        vid: vid,
        autoplay: true,
        canstop: stage !== STAGE_TYPES.isPlayAnswerVideo,
        hidePlayBtn: false,
      }" @ended="onVideoEnded" @ready="onVideoReady" @play="onPlay" v-on="$listeners">
        <LNumber :current="element.currentCount" :total="element.totalCount" class="l-learn-number" />
      </LLearnVideo>
    </div>

    <!-- 答题 -->
    <div class="l-learn-answer" v-if="stage === STAGE_TYPES.isAnswerChoice ||
      stage === STAGE_TYPES.isAnswerRecord
      ">
      <!-- ABC选择题干图片 -->
      <div class="l-learn-answer-stem">
        <LImage :url="currentTestItem.realOptionImageUrl" />
        <LNumber :current="element.currentCount" :total="element.totalCount" class="l-learn-number is-learn-answer" />
      </div>
      <!-- 选择 -->
      <div class="l-abc-choice">
        <LChoice v-if="stage === STAGE_TYPES.isAnswerChoice" :selectionlist="currentTestItem.attrs.selectionList"
          :status="btnStatus" @select="onSelect" />
      </div>
      <!-- 录音 -->
      <div class="l-abc-ecording">
        <lRecorder v-if="stage === STAGE_TYPES.isAnswerRecord" ref="recorder" :disabled="recordStatus == 0"
          :options="recorderOptions" :allow-manual="true" @result="onresult" @init="onRecordInit" />
      </div>
    </div>
  </div>
</template>

<script>
import version from '@/utils/version'
import LLearnVideo from '../l-learn-video'
import LImage from '../../components/l-image'
import LChoice from '../../components/l-button-choice'
import LNumber from '../../components/l-number'
import lRecorder from '../../components/l-recorder'
import elementTypes from '../../minxin/elementTypes'
import ImgupModel from '@/models/imgup'
import localKeyLock from '@/utils/localKeyLock'
import laudio from '@/utils/laudio'
import { recordStudyPlayData } from '@/utils/record'
import { createNamespacedHelpers } from 'vuex'

const { mapGetters, mapActions } = createNamespacedHelpers('course')
const imgup = new ImgupModel()
const ABC_PROCESS = 'ABC_PROCESS'
const ABC_PROCESS_LAST_KEY = `${ABC_PROCESS}_LAST_KEY`

export default {
  components: { LLearnVideo, LImage, LChoice, LNumber, lRecorder },
  mixins: [elementTypes],
  data() {
    return {
      LOCAL_STAGE_KEY: ABC_PROCESS,
      stage: '', // 当前答题阶段
      STAGE_TYPES: {
        isVideoExplain: 'VIDEO_EXPLAIN',
        isAnswerChoice: 'ANSWER_CHOICE',
        isAnswerRecord: 'ANSWER_RECORD',
        isPlayAnswerVideo: 'ANSWER_VIDEO', // 必须看完答案视频
      },
      vid: '', // 当前视频的vid
      isChoice: false, // 题目选择
      refText: '',
      keywords: '',
      currentTestItem: {},
      audioData: null, // 录音数据
      btnStatus: 1, // 1,2,3  选择按钮状态
      recordStatus: 0, // 0,1,2 录音状态
      laudio: null,
      answerAudioUrl: {
        wrong: 'https://bhbl-prod.oss-accelerate.aliyuncs.com/static/wrong.mp3',
        right: 'https://bhbl-prod.oss-accelerate.aliyuncs.com/static/right.mp3',
      },
      recorderOptions: {}, // 录音配置信息
      playTimer: null,
      playTime: 0, // 进入页面开始播放的播放时长
    }
  },
  computed: {
    ...mapGetters(['element']),
  },
  watch: {
    stage(to) {
      if (to === this.STAGE_TYPES.isVideoExplain) {
        this.btnStatus = 1
      } else if (to === this.STAGE_TYPES.isAnswerChoice) {
        this.btnStatus = 2
      } else if (to === this.STAGE_TYPES.isAnswerRecord) {
        this.recordStatus = 1
      } else if (to === this.STAGE_TYPES.isPlayAnswerVideo) {
        console.log('播放答案视频', this.currentTestItem.attrs.answerVideoId)
        this.vid = this.currentTestItem.attrs.answerVideoId
      }
    },
    async 'element.ELEMENT_TYPE'(to) {
      if (to) {
        if (this.element.currentCount > this.element.totalCount) {
          this.$emit('next')
          return
        }
        this.currentTestItem = this.element.datas[this.element.currentCount - 1]
        this.vid = this.currentTestItem.attrs.questionVideoId
        if (this.currentTestItem) {
          this._initSourceUrl()
          // 录音参数
          this.recorderOptions.elementType = this.element.type
          this.recorderOptions.text = (
            await this._getText(this.currentTestItem.attrs.answerTxt)
          ).data[0]
          this.recorderOptions.duration = this.element.attrs.answerRecordTime
          this.recorderOptions.audioFileName = `${this.element.RECORD_ID}-${this.currentTestItem.id}`
        }
      }
    },
  },
  methods: {
    ...mapActions(['STUDY_RESULT']),
    // 录音初始化成功
    onRecordInit() {
      // 提示带耳机，并主动触发开始
      this.$refs.recorder.start()
      this._countTime()
    },
    // 录音完成
    onresult(data) {
      this.onRecordCompleted(data)

      recordStudyPlayData({
        id: this.currentTestItem.id,
        bizType: this.element.type,
        type: 1,
        offset: this.playTime,
      }, this.element.ELEMENT_TYPE)
    },
    onPlay() {
      if (this.stage === this.STAGE_TYPES.isPlayAnswerVideo) {
        if (version.isPC()) {
          this.$refs.player.onFullScreen()
        }
      }
    },
    onSetStatus(status) {
      status == 2 ? status : status == 1
      this.recordStatus = status
    },
    // 手动实现自动播放
    onVideoReady() {
      this.$refs.player.onPlay()
    },
    onVideoEnded() {
      if (this.stage === this.STAGE_TYPES.isVideoExplain) {
        console.log('题目视频播放完成')
        this._localStage({ stage: this.STAGE_TYPES.isAnswerChoice })
      } else if (this.stage === this.STAGE_TYPES.isPlayAnswerVideo) {
        console.log('答案视频播放完成')
        this._submitVideoStatus()
      }
    },
    // 选择
    onSelect(params) {
      this.btnStatus = 3

      // 选择提示音
      if (params.isRight) {
        // 选择正确，去录音
        this.laudio = laudio({
          autoplay: true,
          src: this.answerAudioUrl.right,
        })
      } else {
        // 选择错误，听答案音
        this.laudio = laudio({
          autoplay: true,
          src: this.answerAudioUrl.wrong,
        })
      }

      let tempTimer = setTimeout(() => {
        const selection = {
          option: params.name,
          right: !!params.isRight,
        }
        if (params.isRight) {
          // 选择正确，去录音
          this._localStage({
            stage: this.STAGE_TYPES.isAnswerRecord,
            selection,
          })
        } else {
          // 选择错误,听答案
          this._localStage({
            stage: this.STAGE_TYPES.isPlayAnswerVideo,
            selection: {
              ...selection,
              suggestedScore: 0, // 答错默认0分
            },
          })
        }

        clearTimeout(tempTimer)
        tempTimer = null
      }, 2000)
    },
    // 录音完成
    onRecordCompleted(audioData) {
      this.audioData = audioData
      this._localStage({
        stage: this.STAGE_TYPES.isPlayAnswerVideo,
        audioData: audioData,
      })
    },
    _initSourceUrl() {
      imgup
        .resource({
          paths: [
            this.currentTestItem.attrs.optionImageUrl,
            this.currentTestItem.attrs.rightAudioUrl,
            this.currentTestItem.attrs.wrongAudioUrl,
          ],
        })
        .then((res) => {
          this._initStage()
          this.currentTestItem.realOptionImageUrl = res.data[0]
          this.currentTestItem.realRightAudioUrl = res.data[1]
          this.currentTestItem.realWrongAudioUrl = res.data[2]
        })
        .catch((err) => {
          this._initStage()
          console.log(err.msg)
        })
    },
    //根据关键词修改
    async _getText(text) {
      let res = await imgup.getContent({
        paths: [text],
      })
      return res
    },
    // 初始化当前元素的学习进度
    _initStage() {
      // 当前学习元素+当前学生记录+当前题目
      const currentValueKey = `${ABC_PROCESS}_${this.element.RECORD_ID}_${this.currentTestItem.id}`
      const localKey = ABC_PROCESS_LAST_KEY
      this.LOCAL_STAGE_KEY = localKeyLock(localKey, currentValueKey)

      // 当前测评题提交阶段(0.未提交答案,1.已提交答案但未提交答案视频)
      if (this.element.currentStage === 1) {
        // 直接看答案视频
        this._localStage({ stage: this.STAGE_TYPES.isPlayAnswerVideo })
        return
      }

      try {
        const currentRecord = this._getLocal()
        // 初始化stage数据，什么都没有，则为视频讲解状态
        this.stage =
          currentRecord && currentRecord.stage
            ? currentRecord.stage
            : this.STAGE_TYPES.isVideoExplain

        if (currentRecord) {
          // 录音阶段，且有录音数据，表示上次数据没有提交
          if (
            this.stage === this.STAGE_TYPES.isAnswerRecord &&
            currentRecord.audioData
          ) {
            this.audioData = currentRecord.audioData
          }
        }
      } catch (error) {
        // 报错，默认什么都没有，则为初始化状态
        this._localStage({ stage: this.STAGE_TYPES.isVideoExplain })
      }
    },
    _getLocal() {
      try {
        return JSON.parse(localStorage.getItem(this.LOCAL_STAGE_KEY))
      } catch (err) {
        return null
      }
    },
    // 缓存当前学习进度，防止刷新丢失
    _localStage(params) {
      const localData = this._getLocal() || {}

      if (params) {
        this.stage = params.stage
        params.selection = params.selection
          ? params.selection
          : localData.selection || null
        params.audioData = params.audioData
          ? params.audioData
          : localData.audioData || null
        localStorage.setItem(this.LOCAL_STAGE_KEY, JSON.stringify(params))
      } else {
        localStorage.removeItem(this.LOCAL_STAGE_KEY)
      }
    },
    // 上传答案视频
    _submitVideoStatus() {
      const currentData = this._getLocal()
      this.STUDY_RESULT({
        elementId: this.element.id,
        postData: {
          eleId: this.currentTestItem.id,
          ...(currentData.selection ? currentData.selection : {}),
          ...(currentData.audioData ? currentData.audioData : {}),
        },
      })
        .then(() => {
          // 最后一题
          if (this.element.currentCount === this.element.totalCount) {
            this.$emit('next')
          } else {
            this._localStage()
            location.reload()
          }
        })
        .catch((err) => {
          console.log('提交失败:', err)
        })
    },
    // 播放计时
    _countTime() {
      this.playTimer = setInterval(() => {
        this.playTime += 1
      }, 1000)
    },
  },
  destroyed() {
    this.laudio ? this.laudio.pause() : null
    if (this.playTimer) {
      clearInterval(this.playTimer)
    }
  },
}
</script>

<style lang="stylus">
@import './index.styl'
</style>
